import React from 'react';
import { cn } from '@/lib/utils';

export interface RadioCardProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'title'> {
  title: React.ReactNode;
  description?: React.ReactNode;
  checked?: boolean;
  icon?: React.ReactNode;
}

export const RadioCard = React.forwardRef<HTMLButtonElement, RadioCardProps>(
  ({ className, title, description, checked = false, icon, disabled, ...props }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        role="radio"
        aria-checked={checked}
        disabled={disabled}
        className={cn(
          'w-full text-left rounded-xl border transition-all duration-300 group px-6 py-4 relative overflow-hidden',
          checked
            ? 'border-primary bg-white/90 backdrop-blur-sm text-gray-900 shadow-[0_4px_20px_rgba(20,184,166,0.15)] scale-[1.02] border-2'
            : 'border-gray-200 bg-white hover:border-primary/30 hover:bg-gray-50 hover:shadow-md hover:scale-[1.01]',
          disabled && 'opacity-60 cursor-not-allowed hover:bg-white hover:border-gray-200 hover:scale-100',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40',
          className
        )}
        {...props}
      >
        <div className="flex items-start gap-3">
          {icon && (
            <div
              className={cn(
                'p-2 rounded-full transition-colors',
                checked ? 'bg-primary text-white' : 'bg-gray-100 group-hover:bg-primary/10 text-gray-500 group-hover:text-primary'
              )}
              aria-hidden="true"
            >
              {icon}
            </div>
          )}
          <div className="min-w-0">
            <div className={cn('font-bold text-sm transition-colors', checked ? 'text-gray-900' : 'text-gray-700 group-hover:text-gray-900')}>
              {title}
            </div>
            {description && <div className={cn('text-xs font-medium mt-0.5', checked ? 'text-muted-foreground' : 'text-gray-500')}>{description}</div>}
          </div>
        </div>
      </button>
    );
  }
);
RadioCard.displayName = 'RadioCard';



